exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".py__toggle{font-size:1.42857rem}.fa-toggle-on.py__toggle{color:#6dbb48}.fa-toggle-on.py__toggle:hover{color:#7ed321}.fa-toggle-off.py__toggle{color:#999}.fa-toggle-off.py__toggle:hover{color:#bbb}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/switch/style.css
 ** module id = 1991
 ** module chunks = 73
 **/